/* eslint-disable react/prop-types */
import React, { useContext, useEffect, useState } from 'react';
import { Card, Dropdown } from 'react-bootstrap';
import illustration32 from 'assets/img/spot-illustrations/32.png';
import Button from 'components/base/Button';
import postData from 'services/postData';
import { AuthContext } from 'context/AuthContext';
import { useAlert } from 'providers/AlertModalProvider';
import { formatDate } from 'services/utils';
import Icon from 'components/icon';
import { useModal } from 'providers/ConfirmationModalProvider';

const PunchInOutCard = ({ data = null, refreshData, handlePageLoading }) => {
  const { user } = useContext(AuthContext);
  const [isPunchIn, setIsPunchIn] = useState(false);

  const [isLunchBreakIn, setIsLunchBreakIn] = useState(false);
  const [isLunchBreakDone, setIsLunchBreakDone] = useState(false);
  const [lunchBreakDuration, setLunchBreakDuration] = useState('');

  const [canTakeCasualBreak, setCanTakeCasualBreak] = useState(false);
  const [isCasualBreakIn, setIsCasualBreakIn] = useState(false);
  const [isCasualBreakDone, setIsCasualBreakDone] = useState(false);
  const [casualBreakDuration, setCasualBreakDuration] = useState('');

  const [isWorkingDone, setIsWorkingDone] = useState(false);
  const [workingDuration, setWorkingDuration] = useState('');
  const [totalWorkingDuration, setTotalWorkingDuration] = useState('');

  const [canUserStartWorking, setCanUserStartWorking] = useState(false);
  const [remainingStartShiftTime, setRemainingStartShiftTime] = useState('');

  const { showAlert } = useAlert();

  const { showConfirmation } = useModal();

  useEffect(() => {
    let punchInTimeout;
    let lunchBreakInTimeout;
    let casualBreakInTimeout;
    let remainingStartWorkingInterval;

    if (data) {
      if (!data.punch_in) {
        let currentTime = new Date().getTime();
        const targetTime = new Date(data.shift_start_time).getTime();
        const fifteenMinutes = 15 * 60 * 1000;
        if (currentTime >= targetTime - fifteenMinutes) {
          setCanUserStartWorking(true);
        } else {
          remainingStartWorkingInterval = setInterval(() => {
            const remainingTime = targetTime - fifteenMinutes - currentTime;

            // Check if remaining time is 0 or negative
            if (remainingTime <= 0) {
              setCanUserStartWorking(true);
              clearInterval(remainingStartWorkingInterval); // Stop the interval
              return; // Exit the interval function
            }

            const remainingHours = Math.floor(remainingTime / (60 * 60 * 1000));
            const remainingMinutes = Math.floor(
              (remainingTime % (60 * 60 * 1000)) / (60 * 1000)
            );
            const remainingSeconds = Math.floor(
              (remainingTime % (60 * 1000)) / 1000
            );

            setRemainingStartShiftTime(
              `${remainingHours || ''} ${remainingHours > 0 ? 'hrs' : ''} ${remainingMinutes} min ${remainingSeconds} sec.`
            );

            // Update currentTime for the next iteration
            currentTime = new Date().getTime();
          }, 1000);
        }
      }

      if (data.can_punchin === 0 && !data.punch_out) {
        setIsPunchIn(true);
      } else {
        setIsPunchIn(false);
      }

      if (data.lunch_break && !data.casual_break && data.can_punchin === 1) {
        setIsLunchBreakIn(true);
      }

      if (data.casual_break && !data.lunch_break && data.can_punchin === 1) {
        setIsCasualBreakIn(true);
      }

      if (data.casual_break && data.lunch_break && data.can_punchin === 1) {
        // if both have value check which time is greater (time formate is - 2024-11-27 16:27:10)
        const lunchBreakTime = new Date(data.lunch_break).getTime();
        const casualBreakTime = new Date(data.casual_break).getTime();
        if (lunchBreakTime > casualBreakTime) {
          setIsLunchBreakIn(true);
        } else {
          setIsCasualBreakIn(true);
        }
      }

      if (data.can_punchin === 0) {
        if (data.lunch_break) {
          setIsLunchBreakDone(true); // lunch break done
        }
        if (data.casual_break) {
          setIsCasualBreakDone(true); // casual break doneF
        }
      }

      if (data.punch_out) {
        setIsWorkingDone(true);
        const punchInTime = new Date(data.punch_in).getTime();
        const currentTime = new Date(data.punch_out).getTime();
        const duration = (currentTime - punchInTime) / 1000;
        setTotalWorkingDuration(
          `${Math.floor(duration / 3600)} hrs ${Math.floor((duration / 60) % 60)} min`
        );
      }

      // Permission check
      if (data.can_take_casual_break === 1) {
        setCanTakeCasualBreak(true);
      }

      if (data.punch_in && !data.punch_out) {
        // calculate duration of punch in and out if not available punch out use current time
        punchInTimeout = setInterval(() => {
          const punchInTime = new Date(data.punch_in).getTime();
          const currentTime = data.punch_out
            ? new Date(data.punch_in).getTime()
            : new Date().getTime();
          const duration = (currentTime - punchInTime) / 1000;
          setWorkingDuration(
            `${Math.floor(duration / 3600)} hrs ${Math.floor((duration / 60) % 60)} min`
          );
        }, 1000);
      }

      // Calculate lunch break duration
      if (data.lunch_break) {
        lunchBreakInTimeout = setInterval(() => {
          const lunchBreakStart = new Date(data.lunch_break).getTime();
          const currentTime = new Date().getTime();
          const duration = (currentTime - lunchBreakStart) / 1000;
          setLunchBreakDuration(
            `${Math.floor(duration / 3600)} hrs ${Math.floor((duration / 60) % 60)} min`
          );
        }, 1000);
      }

      // Calculate casual break duration
      if (data.casual_break) {
        casualBreakInTimeout = setInterval(() => {
          const casualBreakStart = new Date(data.casual_break).getTime();
          const currentTime = new Date().getTime();
          const duration = (currentTime - casualBreakStart) / 1000;
          setCasualBreakDuration(
            `${Math.floor(duration / 3600)} hrs ${Math.floor((duration / 60) % 60)} min`
          );
        }, 1000);
      }
    }

    // Cleanup function to clear intervals on unmount
    return () => {
      clearInterval(punchInTimeout);
      clearTimeout(lunchBreakInTimeout);
      clearTimeout(casualBreakInTimeout);
      clearTimeout(remainingStartWorkingInterval);
    };
  }, [data]);

  const handlePunchIn = async () => {
    const tryToPunchIn = async () => {
      handlePageLoading(true, 'Punch In');
      const currentTime = new Date(new Date().getTime() + 5.5 * 60 * 60 * 1000)
        .toISOString()
        .replace('T', ' ')
        .slice(0, -5);

      const payload = {
        user_id: user.user_id,
        user_type: 'Employee',
        punch_in: currentTime
      };
      if (data.punch_master_id) {
        payload['punch_master_id'] = data.punch_master_id;
      }
      const response = await postData(
        payload,
        'https://kalyanierp.com/kalyani-api-v2.1/mobile/user/punch/punch_in',
        { isStaticUrl: true }
      );
      if (response.status) {
        handlePageLoading(false);
        showAlert({
          variant: 'success',
          message: 'Successfully Punch In'
        });
        refreshData();
      } else {
        handlePageLoading(false);
        showAlert({ variant: 'danger', message: response.message });
      }
    };

    showConfirmation({
      onConfirm: async () => tryToPunchIn(),
      message: `Are you sure you want to punch In`,
      severity: 'info',
      confirmBtn: 'Punch In'
    });
  };

  const handlePunchOut = async type => {
    const tryToPunchOut = async () => {
      handlePageLoading(
        true,
        type === 'punch_out'
          ? 'Punch Out'
          : type === 'casual_break'
            ? 'Taking casual break'
            : 'Taking lunch break'
      );
      const currentTime = new Date(new Date().getTime() + 5.5 * 60 * 60 * 1000)
        .toISOString()
        .replace('T', ' ')
        .slice(0, -5);
      const response = await postData(
        {
          user_id: user.user_id,
          user_type: 'Employee',
          punchout_date: currentTime,
          punchout_type: type,
          punch_master_id: data.punch_master_id
        },
        'https://kalyanierp.com/kalyani-api-v2.1/mobile/user/punch/punch_out',
        { isStaticUrl: true }
      );
      if (response.status) {
        handlePageLoading(false);
        showAlert({
          variant: 'success',
          message:
            type === 'punch_out'
              ? 'Successfully Punch Out'
              : type === 'casual_break'
                ? 'Successfully take a casual break'
                : 'Successfully take a LUNCH break'
        });
        refreshData();
      } else {
        handlePageLoading(false);
        showAlert({ variant: 'danger', message: response.message });
      }
    };

    showConfirmation({
      onConfirm: async () => tryToPunchOut(),
      message: `Are you sure you want ${
        type === 'punch_out'
          ? 'Punch Out'
          : type === 'casual_break'
            ? 'take a casual break'
            : 'take a lunch break'
      }`,
      severity: 'info',
      confirmBtn: 'Punch Out'
    });
  };

  return (
    <Card className="border-300 h-100 w-100">
      <div
        className="bg-card bg-holder d-block"
        style={{
          backgroundImage: `url(${illustration32})`,
          backgroundPosition: 'top right'
        }}
      />
      <Card.Body className="px-5 pb-2 position-relative">
        <div className="d-flex justify-content-between">
          <div>
            <h4
              className={`mb-1 text-800 fw-semi-bold title ${!data.punch_in && !canUserStartWorking ? 'text-400' : 'text-primary'}`}
            >
              {isWorkingDone
                ? 'Workday Summary'
                : isLunchBreakIn
                  ? 'You are on a Lunch Break!'
                  : isCasualBreakIn
                    ? 'You are on a Casual Break!'
                    : isPunchIn
                      ? "You're In!"
                      : canUserStartWorking
                        ? 'Start Your Day!'
                        : 'Shift Not Started Yet!'}
            </h4>
            <p className="text-600 fs-9 fw-medium mb-1 description">
              {isWorkingDone ? (
                <>
                  You punched in at:{' '}
                  <span className="text-800">
                    {formatDate(data.punch_in, 'hh:mm A')}
                  </span>{' '}
                  and punched out at:{' '}
                  <span className="text-800">
                    {formatDate(data.punch_out, 'hh:mm A')}
                  </span>
                </>
              ) : isLunchBreakIn ? (
                `You took your lunch break from: ${formatDate(data.lunch_break, 'hh:mm A')}`
              ) : isCasualBreakIn ? (
                `You took your casual break from: ${formatDate(data.casual_break, 'hh:mm A')}`
              ) : data.punch_in ? (
                <>Punching in at: {formatDate(data.punch_in, 'hh:mm A')}</>
              ) : canUserStartWorking ? (
                "It looks like you haven't punched in yet. Begin your work by clicking the button below!"
              ) : (
                `Your shift is scheduled to start at ${formatDate(data.shift_start_time, 'hh:mm A')}.`
              )}
            </p>
          </div>
          {(isCasualBreakDone || isLunchBreakDone) && (
            <div>
              {isLunchBreakDone && (
                <p className="mb-1 w-max-content fs-10">
                  {' '}
                  <Icon
                    icon={'stash:check-circle-light'}
                    className="text-success"
                    fontSize="12px"
                  />{' '}
                  <span className="fw-medium">Lunch break: </span>
                  <span className="fs-10 ">
                    {formatDate(data.lunch_break, 'hh:mm A')}
                  </span>
                </p>
              )}
              {isCasualBreakDone && (
                <p className="mb-1 w-max-content fs-10">
                  {' '}
                  <Icon
                    icon={'stash:check-circle-light'}
                    className="text-success"
                    fontSize="12px"
                  />{' '}
                  <span className="fw-medium">Casual break: </span>
                  <span className="fs-10 ">
                    {formatDate(data.casual_break, 'hh:mm A')}
                  </span>
                </p>
              )}
            </div>
          )}
        </div>
        {(isPunchIn ||
          isWorkingDone ||
          isLunchBreakIn ||
          isCasualBreakIn ||
          !canUserStartWorking) && (
          <div
            className={`d-flex align-items-center flex-wrap gap-2 my-2 total-time ${!isWorkingDone && 'mb-3'}`}
          >
            {isWorkingDone && (
              <>
                <p className="mb-0 fs-8 text-700">Total Working Hrs:</p>
                <h4 className="text-1000 fs-7 fw-medium">
                  {totalWorkingDuration}
                </h4>
              </>
            )}
            {isPunchIn && (
              <>
                <p className="mb-0 fs-8 text-700">Working Hrs:</p>
                <h4 className="text-1000 fs-7 fw-medium">{workingDuration}</h4>
              </>
            )}
            {!data.punch_in && !canUserStartWorking && (
              <>
                <p className="mb-0 fs-8 text-700">Time remaining:</p>
                <h4 className="text-1000 fs-7 fw-medium">
                  {remainingStartShiftTime}
                </h4>
              </>
            )}
            {isLunchBreakIn && (
              <>
                <p className="mb-0 fs-8 text-700">Lunch Break Duration:</p>
                <h4 className="text-1000 fs-7 fw-medium">
                  {lunchBreakDuration}
                </h4>
              </>
            )}
            {isCasualBreakIn && (
              <>
                <p className="mb-0 fs-8 text-700">Casual Break Duration:</p>
                <h4 className="text-1000 fs-7 fw-medium">
                  {casualBreakDuration}
                </h4>
              </>
            )}
          </div>
        )}

        {!isWorkingDone && (
          <div className={`${isPunchIn ? '' : 'mt-5'}`}>
            <>
              {!isPunchIn ? (
                <Button
                  disabled={!data.punch_in && !canUserStartWorking}
                  variant="primary"
                  onClick={handlePunchIn}
                >
                  Punch In
                </Button>
              ) : (
                <div className="d-flex gap-2 flex-wrap">
                  <Button
                    variant="danger"
                    onClick={() => handlePunchOut('punch_out')}
                  >
                    Punch Out
                  </Button>
                  <Dropdown>
                    <Dropdown.Toggle variant="phoenix-secondary">
                      Take Break
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="p-1">
                      <Dropdown.Item
                        className={
                          isLunchBreakDone || isLunchBreakIn
                            ? 'rounded-2 bg-100 text-500'
                            : 'rounded-2'
                        }
                        disabled={isLunchBreakDone || isLunchBreakIn}
                        onClick={() => handlePunchOut('lunch_break')}
                      >
                        <div>Lunch Break</div>

                        {isLunchBreakDone && (
                          <span className="text-warning-300 fs-10">
                            Already taken.
                          </span>
                        )}
                        {!isLunchBreakDone && isLunchBreakIn && (
                          <span className="text-success fs-10">
                            You are currently on break.
                          </span>
                        )}
                      </Dropdown.Item>
                      <Dropdown.Divider className="my-1" />
                      <Dropdown.Item
                        className={
                          isCasualBreakDone || isCasualBreakIn
                            ? 'rounded-2 bg-100 text-500'
                            : !canTakeCasualBreak && !isCasualBreakDone
                              ? 'text-400'
                              : 'rounded-2'
                        }
                        disabled={
                          isCasualBreakDone ||
                          isCasualBreakIn ||
                          (!canTakeCasualBreak && !isCasualBreakDone)
                        }
                        onClick={() => handlePunchOut('casual_break')}
                      >
                        <div>Casual Break</div>
                        {isCasualBreakDone && (
                          <span className="text-warning-300 fs-10">
                            Already taken.
                          </span>
                        )}
                        {!isCasualBreakDone && isCasualBreakIn && (
                          <span className="text-success fs-10">
                            You are currently on break.
                          </span>
                        )}
                        {!canTakeCasualBreak && !isCasualBreakDone && (
                          <span className="text-info fs-10">
                            Permission required. Ask for permission!
                          </span>
                        )}
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              )}
            </>
          </div>
        )}
      </Card.Body>
      <Card.Footer className="border-0 py-0 px-5 z-index-1">
        <p
          className="text-muted note"
          id="small-text"
          style={{ fontSize: '0.7rem' }}
        >
          {isWorkingDone ? (
            'Thank you for your hard work today!'
          ) : (
            <>
              {isPunchIn
                ? 'Remember to punch out at the end of your workday!'
                : !data?.punch_in && !canUserStartWorking
                  ? 'You can punch in up to 15 minutes before your shift'
                  : !data?.punch_in
                    ? 'Begin your workday by clicking the button above!'
                    : 'Remember to punch out at the end of your workday!'}
            </>
          )}
        </p>
      </Card.Footer>
    </Card>
  );
};

export default PunchInOutCard;

// ! Advance function for punch in with handling location and proper status
// const handlePunchIn = async () => {
//   const tryToPunchIn = async () => {
//     handlePageLoading(true, 'Punch In');
//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(
//         async position => {
//           const latitude = position.coords.latitude;
//           const longitude = position.coords.longitude;

//           console.log('🚀 ~ handlePunchIn ~ latitude:', latitude);
//           console.log('🚀 ~ handlePunchIn ~ longitude:', longitude);

//           const currentTime = new Date(
//             new Date().getTime() + 5.5 * 60 * 60 * 1000
//           )
//             .toISOString()
//             .replace('T', ' ')
//             .slice(0, -5);
//           const response = await postData(
//             {
//               user_id: user.user_id,
//               user_type: 'Employee',
//               punch_in: currentTime,
//               punch_master_id: data.punch_master_id
//             },
//             'https://kalyanierp.com/kalyani-api-v2.1/mobile/user/punch/punch_in',
//             { isStaticUrl: true }
//           );
//           if (response.status) {
//             handlePageLoading(false);
//             showAlert({
//               variant: 'success',
//               message: 'Successfully Punch In'
//             });
//             refreshData();
//           } else {
//             handlePageLoading(false);
//             showAlert({ variant: 'danger', message: response.message });
//           }
//         },
//         error => {
//           console.log('🚀 ~ tryToPunchIn ~ error:', error);
//           navigator.permissions
//             .query({ name: 'geolocation' })
//             .then(permissionStatus => {
//               handlePageLoading(false);
//               if (permissionStatus.state === 'prompt') {
//                 showConfirmation({
//                   onConfirm: async () => tryToPunchIn(),
//                   message: (
//                     <>
//                       Location access is required for Punch In. <br /> Please
//                       allow location permissions.
//                     </>
//                   ),
//                   icon: 'streamline:warning-triangle-solid',
//                   severity: 'warning',
//                   confirmBtn: 'Try Again'
//                 });
//               } else if (permissionStatus.state === 'denied') {
//                 showConfirmation({
//                   onConfirm: async () => {
//                     handlePageLoading(true, 'Try to reload the page');
//                     location.reload();
//                   },
//                   message: (
//                     <>
//                       <p className="mb-1">
//                         <strong>Location access has been denied.</strong> <br />{' '}
//                         Please enable location permissions in your browser
//                         settings to use the Punch In.
//                       </p>
//                       <p className="fs-9 text-warning">
//                         If you already enabled, try to reload the page.
//                       </p>
//                     </>
//                   ),
//                   severity: 'danger',
//                   confirmBtn: 'Try To Reload Page'
//                 });
//               }
//             })
//             .catch(error => {
//               console.error('Error checking geolocation permission:', error);
//               handlePageLoading(false);
//               showAlert({
//                 variant: 'danger',
//                 message:
//                   'An error occurred while checking location permissions.'
//               });
//             });
//         }
//       );
//     } else {
//       console.error('Geolocation is not supported by this browser.');
//       handlePageLoading(false);
//       showAlert({
//         variant: 'danger',
//         message: 'Geolocation is not supported by this browser'
//       });
//       // Handle scenario where geolocation is not supported
//     }
//   };

//   showConfirmation({
//     onConfirm: async () => tryToPunchIn(),
//     message: `Are you sure you want to punch In`,
//     severity: 'info',
//     confirmBtn: 'Punch In'
//   });
// };
